export enum ClaimInfoType {
  DAILY_RENTAL_ON_CONTRACT = 1,
  EMPLOYEE_LOSS = 2,
  UNDOCUMENTED_DAMAGE = 3,
  NON_EHI = 4,
  OTHER_VEHICLE_LOSS = 7,
  GENERAL_LIABILITY = 8,
  NOT_DETERMINED = 9,
}
